import React, { useCallback, useContext, useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import "../../src/assets/AdminCss/cricket.css";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { AuthContext, base_url } from "../context/Authcontext";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import CricketScoreboard from "./CricketScoreboard";
import FootballScoreboard from "./FootballScoreboard";
import { useTheme } from "../context/ThemeContext";
import MarqueeBottom from "./components/MarqueeBottom";
import Cookies from "js-cookie";

const FootBAll = () => {
  const [isSidebar, setSidebar] = useState(false);
  const location = useLocation();
  const [back1, setBack1] = useState([]);
  const [lay1, setLay1] = useState([]);
  const [back2, setBack2] = useState([]);
  const [lay2, setLay2] = useState([]);
  const [back3, setBack3] = useState([]);
  const [lay3, setLay3] = useState([]);
  const [backActive, setbackActive] = useState(0);
  const [layActive, setlayActive] = useState(3);
  const [profit, setProfit] = useState(0);
  const [pr, setPr] = useState(0);
  const [active, setActive] = useState(false);
  const { themeColors } = useTheme();
  const [matchLiabilities, setMatchLiabilities] = useState();
  const [oddMatchLiablity, setOddMatchLiablity] = useState();
  const [side, setSide] = useState("");
  const [backLoading, setBackLoading] = useState(false);
  const [layLoading, setLayLoading] = useState(false);

  const [oddsDelay, setOddsDelay] = useState();
  const [unmatch, setUnmatch] = useState([]);

  const [selectedPrice, setSelectedPrice] = useState();
  const [money, setMoney] = useState(0);
  const { isAuthenticated } = useContext(AuthContext);
  const [team1, setTeam1] = useState();
  const [team2, setTeam2] = useState();

  const [marketId, setMarketId] = useState(() => {
    return location.state?.marketId || sessionStorage.getItem("marketId") || "";
  });

  const [runner1, setRunner1] = useState(() => {
    return location.state?.runner1 || sessionStorage.getItem("runner1") || "";
  });

  const [runner2, setRunner2] = useState(() => {
    return location.state?.runner2 || sessionStorage.getItem("runner2") || "";
  });
  const [runner3, setRunner3] = useState(() => {
    return location.state?.runner3 || sessionStorage.getItem("runner3") || "";
  });

  const [selectedId, setSelectedId] = useState(0);
  const [runner, setRunner] = useState("");
  const role = localStorage?.getItem("username");
  const token = Cookies.get("rb_session"); // session flag; the session itself is HttpOnly (#14)

  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  const competiton = sessionStorage.getItem("competitionname");
  const event = sessionStorage.getItem("eventname");
  const selectionid1 = sessionStorage.getItem("selectionid1");
  const selectionid2 = sessionStorage.getItem("selectionid2");
  const selectionid3 = sessionStorage.getItem("selectionid3");

  const eventId = sessionStorage.getItem("eventid");
  const [selectedBet, setSelectedBet] = useState(0);

  const [startTime, setStartTime] = useState();
  const [channel, setChannel] = useState();

  useEffect(() => {
    if (eventId) {
      setChannel(eventId);
    }
  }, []); // run once on mount
  const [betData, setBetData] = useState([]);

  const [play, setPlay] = useState(false);
  const [minOdds, setMinOdds] = useState(0);
  const [maxOdds, setMaxOdds] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 769);

  //
  // console.log("denijhewjihke2", betData);

  // bet form data
  const [formData, setFormData] = useState({
    competiton: competiton,
    eventname: event,
    eventid: 0,
    marketId: marketId,
    selectionId: 0,
    runnername: "",
    betPrice: 0,
    type: "odds",
    betAmount: 0,
    profit: 0,
    side: side,
    sportName: "football",
    team1: runner1,
    team2: runner2,
  });

  // console.log('selec',selectedMarket);

  // console.log('iidd',marketId);

  function formatDate(isoString) {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }

  const handleChange = (action) => {
    // console.log('act',action);

    setMoney((prevMoney) => {
      let newMoney = prevMoney < 0 ? 0 : prevMoney;

      if (action === 0) {
        return Math.max(0, parseFloat(newMoney) - 100);
      } else {
        return parseFloat(newMoney) + 100;
      }
    });
  };

  const handlelayChange = (action) => {
    setSelectedPrice((prev) => {
      let newMoney = prev < 1.01 ? 1.01 : prev;

      if (action === 0) {
        return Math.max(0, (parseFloat(newMoney) - 0.01).toFixed(2));
      } else {
        return (parseFloat(newMoney) + 0.01).toFixed(2);
      }
    });
  };

  useEffect(() => {
    const getTimeDelay = async () => {
      try {
        const res = await axios.get(
          `${base_url}/get/api/webapi/sportsData/timeDelay`,
          {
            params: { eventId },
            withCredentials: true,
            headers: { "content-type": "application/json" },
          }
        );

        const rawDelays = res?.data?.betDelay?.[0]?.delays;
        // console.log("raw delays:", rawDelays);

        // Helper: only use default when value is undefined/null/empty/invalid number.
        const parseNumber = (val, defaultVal) => {
          // console.log('values',val);
          if (val === undefined || val === null) return defaultVal;
          if (typeof val === "string" && val.trim() === "") return defaultVal;
          const n = Number(val);
          return Number.isFinite(n) ? n : defaultVal;
        };

        /* A stake limit of 0 means "nobody filled this in", not "no bets
           allowed": the admin delay form defaults both min and max to 0, so any
           football event saved without limits wrote a zero row -- and 0 is a
           finite number, so it was kept, leaving maxOdds at 0 and rejecting
           every bet on that event. Only the limits get this treatment; a
           bet_delay of 0 legitimately means no delay. */
        const parseLimit = (val, defaultVal) => {
          const n = parseNumber(val, defaultVal);
          return n > 0 ? n : defaultVal;
        };

        let delays = {};
        try {
          delays = rawDelays ? JSON.parse(rawDelays) : {};
        } catch {
          delays = {};
        }

        // Odds
        const parsedMinOdds = parseLimit(delays?.min_bet, 100);
        const parsedMaxOdds = parseLimit(delays?.max_bet, 10000);
        const parsedOddsDelaySec = parseNumber(delays?.bet_delay, 5);

        setMinOdds(parsedMinOdds);
        setMaxOdds(parsedMaxOdds);
        setOddsDelay(parsedOddsDelaySec * 1000);
      } catch (err) {
        console.error("getTimeDelay error:", err);
        /* Without this, minOdds/maxOdds stay at their initial 0 and the
           stake check below ("greater than max value") rejects every bet
           before a request is even sent -- so a failed delay lookup silently
           disabled all football betting. Cricket has had this fallback all
           along, which is why only football was affected. */
        setMinOdds(100);
        setMaxOdds(10000);
        setOddsDelay(0);
      }
    };

    getTimeDelay();
  }, []);

  const betData1 = async () => {
    // Player-only endpoints (401 for a guest): skip them when logged out.
    if (!isAuthenticated) return;
    try {
      const response = await axios.post(
        base_url + "/api/webapi/betData",
        { eventId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      // console.log("databet", response);

      if (response?.data.success) {
        const data = response?.data.sportsBets;
        const unmach = response?.data.unmatch;
        // console.log("ddd", data);
        setBetData(data);
        setUnmatch(unmach);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // formdata odds
  const handleSubmit = async () => {
    if (!isAuthenticated) {
      setActive(true);
      return;
    }
    // if(isTenMinutesRemaining(startTime)){
    //   toast.error('Off Bets! Bets placed only before ten minutes');
    //   return;
    // }

    if (Number(money) < Number(minOdds)) {
      toast.error("Bet cant be placed less than min value");
      return;
    }
    if (Number(money) > Number(maxOdds)) {
      toast.error("Bet cant be placed greater than max value");
      return;
    }

    if (selectedPrice < 1) {
      toast.error("Bet selectedprice is less");
      return;
    }
    // ✅ Ensure `oddsDelay` has a valid value
    const delay = oddsDelay || 0;
    if (delay > 0) {
      if (side === "Back") {
        setBackLoading(true);
        setLayLoading(false);
      } else if (side === "Lay") {
        setLayLoading(true);
        setBackLoading(false);
      }
    }

    setTimeout(async () => {
      if (side === "Back") {
        const allBackPrices = [...back1, ...back2, ...back3];

        /* Compared with Number() on both sides: typing or stepping the odds
           field makes selectedPrice a string, while the vendor's price is a
           number, so `===` never matched and every hand-entered price was
           rejected. */
        const valuee = allBackPrices.some(
          (bac) => Number(bac.price) === Number(selectedPrice),
        );

        /* The early return that used to sit here claimed the bet had gone to
           unmatched and then returned without storing it anywhere -- no bet,
           no unmatched row -- which made the block below dead code. Fall
           through to it so the bet really is recorded as unmatched. */
        if (!valuee) {
          try {
            const response = await axios.post(
              base_url + "/api/webapi/unmatched",
              formData,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json",
                },
              }
            );

            if (response?.data.success) {
              toast.error("Bet placed to unmatched due to value change");
              setbackActive(0);
              setlayActive(3);
              setSelectedBet(0);
              betData1();
            }
          } catch (err) {
            console.log(err);
          } finally {
            if (delay > 0) setBackLoading(false);
            setLayLoading(false);
          }

          return;
        }
      }

      if (side === "Lay") {
        const allLayPRices = [...lay1, ...lay2, ...lay3];
        // Same two fixes as the Back side above: numeric comparison, and no
        // early return that drops the bet while claiming it was stored.
        const values = allLayPRices.some(
          (lay) => Number(lay.price) === Number(selectedPrice),
        );

        if (!values) {
          try {
            const response = await axios.post(
              base_url + "/api/webapi/unmatched",
              formData,
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json",
                },
              }
            );

            if (response?.data.success) {
              toast.error("Bet placed to unmatched due to value change");
              setbackActive(0);
              setlayActive(3);
              setSelectedBet(0);
              betData1();
            }
          } catch (err) {
            console.log(err);
          } finally {
            if (delay > 0) setBackLoading(false);
            setLayLoading(false);
          }

          return;
        }
      }

      try {
        const response = await axios.post(
          base_url + "/api/webapi/sportsData",
          formData,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );

        // console.log("formmatch", response);

        if (response?.data.success) {
          toast.success(response?.data.message);
          setbackActive(0);
          setlayActive(3);
          setSelectedBet(0);
          betData1();
          getMatchLiabilities();
        } else {
          toast.error(response?.data.message);
        }
      } catch (err) {
        console.log(err);
        toast.error("Failed to place bet");
      } finally {
        if (delay > 0) setBackLoading(false);
        setLayLoading(false);
      }
    }, delay);
  };

  const calculatePnLByMarket = (bets, team1, team2) => {
    const marketTypes = ["odds", "bookmaker", "mini_bookmaker"];
    const result = {};

    marketTypes.forEach((market) => {
      const marketBets = bets?.filter((b) => {
        const betType = b?.type
          ?.toString()
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "");
        return betType === market;
      });

      // console.log(market, marketBets, "fev");

      const runnerPnl = {};

      // Collect unique runners
      const runners = new Set(marketBets.map((b) => b.runnerName));
      runners.add(team1);
      runners.add(team2);
      // Check if runner3 (i.e., "The Draw") exists in sessionStorage
      const runner3 = sessionStorage.getItem("runner3");
      if (runner3 && runner3.toLowerCase() === "the draw") {
        runners.add("The Draw");
      }

      // Initialize PnL
      for (const runner of runners) {
        runnerPnl[runner] = 0;
      }

      // Calculate PnL
      marketBets?.forEach(({ runnerName, side, betprice, betAmount }) => {
        const odds = parseFloat(betprice);
        const stake = parseFloat(betAmount);

        for (const currentRunner of runners) {
          if (marketBets[0].type === "book maker") {
            // console.log(runners, "marketBets2");
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (stake * odds) / 100;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (stake * odds) / 100;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          } else {
            if (currentRunner === runnerName) {
              if (side === "Back") {
                runnerPnl[currentRunner] += (odds - 1) * stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] -= (odds - 1) * stake;
              }
            } else {
              if (side === "Back") {
                runnerPnl[currentRunner] -= stake;
              } else if (side === "Lay") {
                runnerPnl[currentRunner] += stake;
              }
            }
          }
        }
      });

      // Round to 2 decimal places
      Object.keys(runnerPnl).forEach((runner) => {
        runnerPnl[runner] = parseFloat(runnerPnl[runner].toFixed(2));
      });

      // Calculate liability (worst case)
      const liability = Object.values(runnerPnl).length
        ? Math.min(...Object.values(runnerPnl))
        : 0;

      result[market] = {
        pnl: runnerPnl,
        liability: parseFloat(liability.toFixed(2)),
      };
    });

    return result;
  };

  const getMatchLiabilities = async () => {
    // Player-only endpoints (401 for a guest): skip them when logged out.
    if (!isAuthenticated) return;
    try {
      const response = await axios.get(
        `${base_url}/api/webapi/getMatchLiablity/${eventId}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const bets = response.data.liabilities || []; // ✅ fix here

      console.log(response.data, "bets after fix");

      const { team1, team2 } = bets[0] || {};

      const result = calculatePnLByMarket(bets, team1, team2);

      setMatchLiabilities(result);
    } catch (error) {
      console.error("Error fetching match liabilities:", error);
    }
  };

  useEffect(() => {
    getMatchLiabilities();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    if (location.state?.marketId) {
      sessionStorage.setItem("marketId", location.state.marketId);
      setMarketId(location.state.marketId);
    }

    if (location.state?.runner1) {
      sessionStorage.setItem("runner1", location.state.runner1);
      setRunner1(location.state.runner1);
    }

    if (location.state?.runner2) {
      sessionStorage.setItem("runner2", location.state.runner2);
      setRunner2(location.state.runner2);
    }

    if (location.state?.runner3) {
      sessionStorage.setItem("runner3", location.state.runner3);
      setRunner3(location.state.runner3);
    }

    const backLay = async () => {
      try {
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log('reees',response);
        const status1 = response?.data.result[0]?.status;
        const status2 = response?.data.result[1]?.status;
        const status3 = response?.data.result[2]?.status;
        // console.log(status1);
        // console.log(status2);

        if (status1 === "ACTIVE") {
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);
        }

        if (status2 === "ACTIVE") {
          const backk2 = response?.data.result[1]?.ex?.availableToBack;
          const layy2 = response?.data.result[1]?.ex?.availableToLay;

          setBack2(backk2);
          setLay2(layy2);
        }
        if (status3 === "ACTIVE") {
          const backk3 = response?.data.result[2]?.ex?.availableToBack;
          const layy3 = response?.data.result[2]?.ex?.availableToLay;

          setBack3(backk3);
          setLay3(layy3);
        }
      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

    const liveTv = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/liveTv");
        const live = response?.data.result;
        const matchedData = live.filter(
          (item) => item.MatchID === parseFloat(eventId)
        );
        const channel = matchedData[0].Channel;

        // Get the TV URL from your API
        const respone = await axios.post(base_url + "/api/webapi/tv/channel", {
          channel,
        });
        const tvLink = respone?.data.message;

        // Set the full URL with proper encoding
        setChannel(encodeURI(tvLink));
      } catch (err) {
        console.log(err);
      }
    };

    const proft =
      parseFloat(selectedPrice) * parseFloat(money) - parseFloat(money);
    setProfit(proft.toFixed(1));

    // console.log('prff',proft);
    // Add event listener for resize
    window.addEventListener("resize", handleResize);
    handleResize();
    backLay();
    liveTv();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      // sessionStorage.clear();
    };
  }, [location.state, money, selectedPrice]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const backLay = async () => {
      try {
        const response = await axios.get(
          base_url + `/api/webapi/market/${marketId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("reees", response);
        const status1 = response?.data.result[0]?.status;
        const status2 = response?.data.result[1]?.status;
        const status3 = response?.data.result[2]?.status;
        // console.log(status1);
        // console.log(status2);

        if (status1 === "ACTIVE") {
          const backk1 = response?.data.result[0]?.ex?.availableToBack;
          const layy1 = response?.data.result[0]?.ex?.availableToLay;

          setBack1(backk1);
          setLay1(layy1);
        }

        if (status2 === "ACTIVE") {
          const backk2 = response?.data.result[1]?.ex?.availableToBack;
          const layy2 = response?.data.result[1]?.ex?.availableToLay;

          setBack2(backk2);
          setLay2(layy2);
        }
        if (status3 === "ACTIVE") {
          const backk3 = response?.data.result[2]?.ex?.availableToBack;
          const layy3 = response?.data.result[2]?.ex?.availableToLay;

          setBack3(backk3);
          setLay3(layy3);
        }
      } catch (err) {
        console.log("Error fetching in odds data", err);
      }
    };

    const sessiontime = sessionStorage.getItem("time");
    const time = formatDate(sessiontime);
    // console.log('time',time);
    setStartTime(time);

    const updateData = () => {
      backLay();
    };

    betData1();

    const intervalId = setInterval(updateData, 1000);

    // Cleanup function to clear interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  // console.log('matchess',wpMarket);

  // betformdata
  formData.selectionId = selectedId;
  formData.runnername = runner;
  formData.betAmount = money;
  formData.profit = profit;
  formData.eventid = eventId;
  formData.betPrice = selectedPrice;
  formData.side = side;

  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const gridStyle = {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(6, 1fr)" : "repeat(12, 1fr)",
    gap: "5px",
    marginBottom: "0",
  };

  return (
    <>
      <style>
        {`
      @media (min-width: 1200px){
    .fs-3 {
        font-size: 1.25rem !important;
    }
}
      `}
      </style>
      {<LoginReg active={active} setactive={setActive} />}
      <app-root _nghost-jrx-c101="" ng-version="12.2.16">
        <div _ngcontent-jrx-c101="" className="rightbar">
          <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
            <div _ngcontent-jrx-c95="" className="head-container">
              <Header
                isSidebar={isSidebar}
                setSidebar={setSidebar}
                show={showCanvas}
                handleShow={handleCanvasShow}
                handleClose={handleCanvasClose}
              />
              <div _ngcontent-jrx-c95="" className="body-container">
                <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />

                <div
                  _ngcontent-jrx-c95=""
                  className="rightbar d-flex flex-column"
                  style={{
                    width: isSidebar ? "" : "2500%",
                    transition: "width 0.3s ease-in-out",
                  }}
                >
                  <div className="d-flex flex-column flex-lg-row justify-content-between mainn w-100 rb-match">
                    <div
                      className="match-content"
                      style={{ backgroundColor: "var(--dark-theme-data-bg)" }}
                    >
                      {role !== "demo" && token && (
                        <div
                          className="
                            livetvv position-relative"
                        >
                          <div
                            className="p-2 cursor-pointer d-flex justify-content-between bg-black"
                            onClick={() => setPlay(!play)}
                          >
                            <div>
                              <span>
                                <i
                                  className="bi bi-broadcast fs-16"
                                  style={{
                                    color: "var(--dark-theme-demoaccount)",
                                  }}
                                ></i>
                              </span>
                              <span> Watch Live Match</span>
                            </div>
                            <div>
                              <button className="live-stream-button ng-star-inserted">
                                Watch Live
                              </button>
                            </div>
                          </div>

                          {play && channel && (
                            <iframe
                              title="Live TV"
                              className="border w-100 "
                              style={{ height: "26vh" }}
                              // src={`https://cache.bpexchanges.com/embed?eventId=${channel}`}
                              src={`/proxy-stream/${channel}`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>
                          )}
                        </div>
                      )}

                      {/* <iframe
                        src={`https://trovetown.co/score/sportRadar/?eventId=${sessionStorage.getItem(
                          "eventid"
                        )}`}
                        style={{
                          width: "100%",
                          height: "600px",
                          border: "none",
                        }}
                        title="Live Scoreboard"
                      /> */}

                      {/* <p className="breadcrumb mt-3"  style={{fontFamily:"sans-serif",color:"grey"}}>
                            Home &gt; FootBall &gt; {competiton} &gt;
                            {event} &gt; Match Odds
                          </p>

                          <div className="d-flex gap-5 align-items-center">
                            <span className="text-info fs-5 inline">Start Time: &nbsp;{startTime}</span>
                            <span>Time Remaining: </span>
                          </div>
                      */}

                      {/* Which match this is -- the page opened straight on
                          the markets with no teams, competition or start
                          time (same header as the cricket page). */}
                      {event && (
                        <header className="rb-match__head" id="rb-match-top">
                          <h1 className="rb-match__title">{event}</h1>
                          <p className="rb-match__meta">
                            {competiton}
                            {competiton && startTime ? " · " : ""}
                            {startTime}
                          </p>
                        </header>
                      )}

                      {/* <CricketScoreboard />  */}
                      {role !== "demo" && token ? <FootballScoreboard /> : ""}

                      {/* {role !== 'demo' && token ?
                        (<iframe
                              title="Live TV"
                              className="border w-100 "
                              style={{ height: isLargeScreen ? "28vh" : "33vh" }}
                              src={`https://e765432.diamondcricketid.com/sr.php?eventid=${eventId}&sportid=1`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>) : ""
                      } */}

                      <div
                        className="match-section mb-1"
                        style={{ color: "var(--dark-theme-color-navbar)" }}
                      >
                        <div
                          className="match-header align-items-end"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                "var(--dark-theme-time-remaining)",
                              marginTop: isLargeScreen ? "0px" : "3px",
                            }}
                            className="d-flex mb-1 flex-lg-row flex-row me-1 flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                              className="py-1 me-3 d-flex fw-bold mb-0 px-2 rad bett"
                            >
                              Match odds
                            </p>
                            <p
                              className="d-flex gap-1 ms-auto me-2 mb-0 fszz fw-bold"
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                            >
                              <span
                                style={{
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                          </div>

                          {/* <p className="btn btn-success rounded-pill text-black"  style={{marginBottom:"14px"}}>
                          Cashout
                        </p> */}

                          <div
                            className="d-flex gap-1"
                            style={{
                              height: "1.5rem",
                              marginRight: isLargeScreen ? "9rem" : "0.5rem",
                            }}
                          >
                            <p
                              className="fs-6 px-2 mb-0 ms-auto bgInfo"
                              style={{
                                borderTopLeftRadius: "20px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "5px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-3 mb-0 bg-pink1"
                              style={{
                                borderTopLeftRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "20px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div className="betting-options d-flex flex-column">
                          <div
                            style={{ borderBottom: "1px solid #d3cece" }}
                            className="betting-row d-flex flex-md-row justify-content-between  rounded align-items-center border-2 p-1"
                          >
                            <h5
                              className="fs-4 text-wrap run d-flex flex-col"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid1}
                            >
                              <span>{runner1}</span> {""}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner1] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner1]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {/* {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner1] || 0
                                ) + parseFloat(oddMatchLiablity || 0)} */}

                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner1] || 0
                                ) +
                                  parseFloat(oddMatchLiablity || 0) ===
                                0
                                  ? ""
                                  : parseFloat(
                                      matchLiabilities?.odds?.pnl?.[runner1] ||
                                        0
                                    ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-red"
                                    : pr === 3 || pr === 17
                                    ? "d-block text-red"
                                    : pr === 4 || pr === 18
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 3 || pr === 17
                                  ? -money
                                  : pr === 4 || pr === 18
                                  ? money
                                  : pr === 1
                                  ? profit
                                  : -profit}
                              </span>

                              {back1
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                      index < back1.length - 1
                                        ? "bg-secondary1 dnone"
                                        : "bg-info1"
                                    }`}
                                    onClick={() => {
                                      setbackActive(1);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(1);
                                      setSelectedId(selectionid1);
                                      setRunner(runner1);
                                      setSide("Back");
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: "4rem", fontSize: "1rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay1.map((bc, index) => (
                                <div
                                  className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bg-secondary1 dnone"
                                  }`}
                                  onClick={() => {
                                    setlayActive(4);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(2);
                                    setSelectedId(selectionid1);
                                    setRunner(runner1);
                                    setSide("Lay");
                                    setSelectedBet(0);
                                  }}
                                  style={{ width: "4rem" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>

                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-1 p-1"
                            style={{ borderBottom: "1px solid #d3cece" }}
                          >
                            <h5
                              className="fs-4 text-wrap run m-0 d-flex flex-col"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid2}
                            >
                              {runner2}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner2] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner2]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {/* {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner2] || 0
                                ) + parseFloat(oddMatchLiablity || 0)} */}

                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner2] || 0
                                ) +
                                  parseFloat(oddMatchLiablity || 0) ===
                                0
                                  ? ""
                                  : parseFloat(
                                      matchLiabilities?.odds?.pnl?.[runner2] ||
                                        0
                                    ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-red"
                                    : pr === 1 || pr === 17
                                    ? "d-block text-red"
                                    : pr === 2 || pr === 18
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 1 || pr === 17
                                  ? -money
                                  : pr === 2 || pr === 18
                                  ? money
                                  : pr === 3
                                  ? profit
                                  : -profit}
                              </span>

                              {back2
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                      index < back2.length - 1
                                        ? "bg-secondary1 dnone"
                                        : "bg-info1"
                                    }`}
                                    onClick={() => {
                                      setbackActive(2);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(3);
                                      setSide("Back");
                                      setSelectedId(selectionid2);
                                      setRunner(runner2);
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay2.map((bc, index) => (
                                <div
                                  className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bg-secondary1 dnone"
                                  }`}
                                  onClick={() => {
                                    setlayActive(5);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(4);
                                    setSelectedId(selectionid2);
                                    setRunner(runner2);
                                    setSelectedBet(0);
                                    setSide("Lay");
                                  }}
                                  style={{ width: "4rem" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>
                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-1 p-1"
                            style={{ borderBottom: "1px solid #d3cece" }}
                          >
                            <h5
                              className="fs-4 text-wrap run m-0 d-flex flex-col"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid3}
                            >
                              {runner3}
                              <span
                                className={`${
                                  (matchLiabilities?.odds?.pnl?.[runner3] !==
                                  undefined
                                    ? matchLiabilities.odds.pnl[runner3]
                                    : parseFloat(oddMatchLiablity)) < 0
                                    ? "text-red"
                                    : "text-green"
                                }`}
                              >
                                {parseFloat(
                                  matchLiabilities?.odds?.pnl?.[runner3] || 0
                                ) +
                                  parseFloat(oddMatchLiablity || 0) ===
                                0
                                  ? ""
                                  : parseFloat(
                                      matchLiabilities?.odds?.pnl?.[runner3] ||
                                        0
                                    ) + parseFloat(oddMatchLiablity || 0)}
                              </span>
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 17
                                    ? "d-block text-green"
                                    : pr === 18
                                    ? "d-block text-red"
                                    : pr === 1 || pr === 3
                                    ? "d-block text-red"
                                    : pr === 2 || pr === 4
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {pr === 1 || pr === 3
                                  ? -money
                                  : pr === 3 || pr === 4
                                  ? -money
                                  : pr === 17
                                  ? profit
                                  : -profit}
                              </span>

                              {back3
                                .slice()
                                .reverse()
                                .map((bc, index) => (
                                  <div
                                    className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                      index < back2.length - 1
                                        ? "bg-secondary1 dnone"
                                        : "bg-info1"
                                    }`}
                                    onClick={() => {
                                      setbackActive(2);
                                      setlayActive(3);
                                      setSelectedPrice(bc.price);
                                      setPr(17);
                                      setSide("Back");
                                      setSelectedId(selectionid3);
                                      setRunner(runner3);
                                      setSelectedBet(0);
                                    }}
                                    style={{ width: "4rem" }}
                                  >
                                    {bc.price}
                                  </div>
                                ))}

                              {lay3.map((bc, index) => (
                                <div
                                  className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                    index === 0
                                      ? "bg-pink1"
                                      : "bg-secondary1 dnone"
                                  }`}
                                  onClick={() => {
                                    setlayActive(5);
                                    setbackActive(0);
                                    setSelectedPrice(bc.price);
                                    setPr(18);
                                    setSelectedId(selectionid3);
                                    setRunner(runner3);
                                    setSelectedBet(0);
                                    setSide("Lay");
                                  }}
                                  style={{ width: "4rem" }}
                                >
                                  {bc.price}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* betting back div */}
                        {backActive !== 0 && (
                          <div
                            style={{
                              backgroundColor: "var(--dark-theme-data-homebet)",
                              padding: "5px",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            {backLoading ? (
                              // 🔹 Spinner Overlay
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "5px",
                                  zIndex: 10,
                                }}
                              >
                                <div
                                  style={{
                                    border:
                                      "4px solid var(--dark-theme-card-bg-light2)",
                                    borderTop:
                                      "4px solid var(--dark-theme-data-submit)",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    animation: "spin 1s linear infinite",
                                  }}
                                />
                              </div>
                            ) : null}
                            {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                              <button
                                style={{ backgroundColor: 'var(--dark-theme-data-backbtn)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                BACK
                              </button>
                              <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                marginBottom: "5px",
                              }}
                            >
                              <div>
                                {/* <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handlelayChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={selectedPrice}
                                    onChange={(e) =>
                                      setSelectedPrice(e.target.value)
                                    }
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      border: "none",
                                      width: "84px",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handlelayChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <div>
                                {/* <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handleChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={money}
                                    onChange={(e) => setMoney(e.target.value)}
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      width: "84px",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      backgroundColor:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handleChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(100)}
                              >
                                + 100
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(500)}
                              >
                                + 500
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(1000)}
                              >
                                + 1k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                className="homebet_set"
                                style={{
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div>
                            {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                              <button
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(5000)}
                              >+ 5k</button>
                              <button
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(10000)}
                              >+ 10k</button>
                              <button
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(25000)}
                              >+ 25k</button>
                              <button
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(50000)}
                              >+ 50k</button>
                            </div> */}

                            {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                              <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                              <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                              <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                              <button
                                style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >Clear</button>
                            </div> */}

                            {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                              <button
                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >Cancel</button>
                              <button
                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                onClick={() => handleSubmit()}
                              >Submit</button>
                            </div> */}
                          </div>
                        )}
                        {layActive !== 3 && (
                          <div
                            style={{
                              backgroundColor:
                                "var(--dark-theme-data-homebet2)",
                              padding: "5px",
                              color: "var(--dark-theme-color-navbar)",
                              borderRadius: "5px",
                              width: "100%",
                            }}
                          >
                            {layLoading ? (
                              // 🔹 Spinner Overlay
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "5px",
                                  zIndex: 10,
                                }}
                              >
                                <div
                                  style={{
                                    border:
                                      "4px solid var(--dark-theme-card-bg-light2)",
                                    borderTop:
                                      "4px solid var(--dark-theme-data-submit)",
                                    borderRadius: "50%",
                                    width: "32px",
                                    height: "32px",
                                    animation: "spin 1s linear infinite",
                                  }}
                                />
                              </div>
                            ) : null}
                            {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                              <button
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Lay
                              </button>
                              <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                                Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                              </div>
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                                <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                              </div>
                            </div> */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                gap: "10px",
                                marginBottom: "5px",
                              }}
                            >
                              <div>
                                {/* <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      background:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handlelayChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={selectedPrice}
                                    onChange={(e) =>
                                      setSelectedPrice(e.target.value)
                                    }
                                    style={{
                                      background:
                                        "var(--dark-theme-color-navbar)",
                                      width: "84px",
                                      color: "var(--dark-theme-white-color)",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      background:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handlelayChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <div>
                                {/* <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div> */}
                                <div
                                  style={{ display: "flex", height: "30px" }}
                                >
                                  <button
                                    style={{
                                      background:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "4px 0 0 4px",
                                    }}
                                    onClick={() => handleChange(0)}
                                  >
                                    −
                                  </button>
                                  <input
                                    type="text"
                                    value={money}
                                    onChange={(e) => setMoney(e.target.value)}
                                    style={{
                                      background:
                                        "var(--dark-theme-color-navbar)",
                                      color: "var(--dark-theme-white-color)",
                                      width: "84px",
                                      border: "none",
                                      flex: 1,
                                      textAlign: "center",
                                      fontSize: "13px",
                                    }}
                                  />
                                  <button
                                    style={{
                                      background:
                                        "var(--dark-theme-card-bg-light2)",
                                      color: "var(--dark-theme-color-navbar)",
                                      width: "22px",
                                      border: "none",
                                      fontSize: "13px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "0 4px 4px 0",
                                    }}
                                    onClick={() => handleChange(1)}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div style={gridStyle}>
                              <div></div>
                              <div></div>
                              <div></div>
                              <div></div>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(100)}
                              >
                                + 100
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(500)}
                              >
                                + 500
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(1000)}
                              >
                                + 1k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(5000)}
                              >
                                + 5k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(10000)}
                              >
                                + 10k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-set2)",
                                  color: "var(--dark-theme-white-color)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => setMoney(50000)}
                              >
                                + 50k
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-cancel)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                style={{
                                  background: "var(--dark-theme-data-submit)",
                                  color: "var(--dark-theme-color-navbar)",
                                  padding: "5px 0",
                                  border: "none",
                                  borderRadius: "3px",
                                  fontWeight: "bold",
                                }}
                                onClick={() => handleSubmit()}
                              >
                                Submit
                              </button>
                            </div>

                            {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                              <button
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(5000)}
                              >+ 5k</button>
                              <button
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(10000)}
                              >+ 10k</button>
                              <button
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(25000)}
                              >+ 25k</button>
                              <button
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                                onClick={() => setMoney(50000)}
                              >+ 50k</button>
                            </div> */}

                            {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                              <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                              <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                              <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                              <button
                                style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                onClick={() => {
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >Clear</button>
                            </div> */}

                            {/* <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                              <button
                                style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                onClick={() => {
                                  setbackActive(0);
                                  setMoney(0);
                                  setPr(0);
                                }}
                              >Cancel</button>
                              <button
                                style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                                onClick={() => handleSubmit()}
                              >Submit</button>
                            </div> */}
                          </div>
                        )}
                      </div>

                      <div
                        className="match-section mb-1"
                        style={{ color: "var(--dark-theme-color-navbar)" }}
                      >
                        <div
                          className="match-header align-items-end"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                "var(--dark-theme-time-remaining)",
                              marginTop: isLargeScreen ? "0px" : "3px",
                            }}
                            className="d-flex mb-1 flex-lg-row flex-row me-1 flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                              className="py-1 me-3 d-flex fw-bold mb-0 px-2 rad bett"
                            >
                              Over/Under 2.5 Goals
                            </p>
                            <p
                              className="d-flex gap-1 ms-auto me-2 mb-0 fszz fw-bold"
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                            >
                              <span
                                style={{
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                          </div>

                          {/* <p className="btn btn-success rounded-pill text-black"  style={{marginBottom:"14px"}}>
                          Cashout
                        </p> */}

                          <div
                            className="d-flex gap-1"
                            style={{
                              height: "1.5rem",
                              marginRight: isLargeScreen ? "9rem" : "0.5rem",
                            }}
                          >
                            <p
                              className="fs-6 px-3 mb-0 ms-auto bgInfo"
                              style={{
                                borderTopLeftRadius: "20px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "5px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-3 mb-0 bg-pink1"
                              style={{
                                borderTopLeftRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "20px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div
                          className="betting-options d-flex flex-column p-2 gap-2"
                          style={{ marginLeft: "-10px" }}
                        >
                          <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-1 p-1">
                            <h5
                              className="fs-4 text-wrap run m-0"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid1}
                            >
                              {runner1}
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 5
                                    ? "d-block text-green"
                                    : pr === 6
                                    ? "d-block text-red"
                                    : pr === 7
                                    ? "d-block text-red"
                                    : pr === 8
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===7 ? -money : pr===8 ? money : pr === 5 ? profit : -profit} */}
                              </span>
                              SUSPENDED
                              {/* 
                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-3 h-75 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bg-secondary1 dnone"
                                    : "bg-info1"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                  setSelectedBet(0)
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-3 h-75 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary1 dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>

                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-1 p-1"
                            style={{ borderBottom: "1px solid #d3cece" }}
                          >
                            <h5
                              className="fs-4 text-wrap run m-0"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid2}
                            >
                              {runner2}
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 7
                                    ? "d-block text-green"
                                    : pr === 8
                                    ? "d-block text-red"
                                    : pr === 5
                                    ? "d-block text-red"
                                    : pr === 6
                                    ? "d-block text-green"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===5 ? -money : pr===6 ? money : pr=== 7 ? profit : -profit } */}
                              </span>
                              SUSPENDED
                              {/*                        
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index < back2.length - 1
                                    ? "bg-secondary1 dnone"
                                    : "bg-info1"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index === 0 ? "bg-pink1" : "bg-secondary1 dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>
                          {/* <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-1 p-1" style={{ borderBottom: "1px solid #d3cece" }}>
                          <h5 className="fs-4 text-wrap run m-0" style={{ color: 'var(--dark-theme-white-color)' }} id={selectionid3}>{runner3}</h5>
                          
                          <div className="d-flex gap-1" style={{ color: 'var(--dark-theme-white-color)' }}>
                          <span
                              className={`${
                                pr === 17
                                  ? "d-block text-green"
                                  : pr === 18
                                  ? "d-block text-green"
                                  : (pr===1 || pr===2  || pr===3 || pr === 4) 
                                  ? 'd-block text-red'
                                  : 'd-none'
                              }`}
                            >
                              {"=>"}
                              {pr===1 || pr===2 || pr===3 || pr === 4 ? -money : profit }
                            </span>
                       
                            {back3.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index < back2.length - 1
                                    ? "bg-secondary1 dnone"
                                    : "bg-info1"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(17);
                                  setSelectedId(selectionid3);
                                  setRunner(runner3);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay3.map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index === 0 ? "bg-pink1" : "bg-secondary1 dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(18);
                                  setSelectedId(selectionid3);
                                  setRunner(runner3);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                          </div>
                        </div> */}
                        </div>

                        {/* betting back div */}
                        {/* {backActive !== 0 && (
                        <div style={{ backgroundColor: 'var(--dark-theme-data-homebet)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: 'var(--dark-theme-data-backbtn)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div    style={{ display: "flex", alignItems: "center" }  }>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                         {layActive !== 3 && (
                        <div style={{ backgroundColor: 'var(--dark-theme-data-homebet2)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )} */}
                      </div>
                      <div
                        className="match-section mb-1"
                        style={{ color: "var(--dark-theme-color-navbar)" }}
                      >
                        <div
                          className="match-header align-items-end"
                          style={{ borderBottom: "1px solid #d3cece" }}
                        >
                          <div
                            style={{
                              backgroundColor:
                                "var(--dark-theme-time-remaining)",
                              marginTop: isLargeScreen ? "0px" : "3px",
                            }}
                            className="d-flex mb-1 flex-lg-row flex-row me-1 flex-md-row align-items-baseline"
                          >
                            <p
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                              className="py-1 me-3 d-flex fw-bold mb-0 px-2 rad bett"
                            >
                              over/under 0.5 goals
                            </p>
                            <p
                              className="d-flex gap-1 ms-auto me-2 mb-0 fszz fw-bold"
                              style={{
                                color: "var(--dark-theme-color-navbar)",
                              }}
                            >
                              <span
                                style={{
                                  color: "var(--dark-theme-color-navbar)",
                                }}
                              >
                                Min:{minOdds} <span>|</span>{" "}
                              </span>{" "}
                              Max:{maxOdds}
                            </p>
                          </div>

                          {/* <p className="btn btn-success rounded-pill text-black"  style={{marginBottom:"14px"}}>
                          Cashout
                        </p> */}

                          <div
                            className="d-flex gap-1"
                            style={{
                              height: "1.5rem",
                              marginRight: isLargeScreen ? "9rem" : "0.5rem",
                            }}
                          >
                            <p
                              className="fs-6 px-3 mb-0 ms-auto bgInfo"
                              style={{
                                borderTopLeftRadius: "20px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "5px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Back
                            </p>
                            <p
                              className="fs-6 px-3 mb-0 bg-pink1"
                              style={{
                                borderTopLeftRadius: "5px",
                                borderBottomLeftRadius: "5px",
                                borderTopRightRadius: "20px",
                                borderBottomRightRadius: "5px",
                                border: "1px solid #c1bdbd",
                              }}
                            >
                              Lay
                            </p>
                          </div>
                        </div>

                        <div
                          className="betting-options d-flex flex-column p-2 gap-2"
                          style={{ marginLeft: "-10px" }}
                        >
                          <div className="betting-row d-flex flex-md-row justify-content-between align-items-center border-1 p-1">
                            <h5
                              className="fs-4 text-wrap run m-0"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid1}
                            >
                              {runner1}
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 1
                                    ? "d-block text-green"
                                    : pr === 2
                                    ? "d-block text-green"
                                    : pr === 3 ||
                                      pr === 4 ||
                                      pr === 17 ||
                                      pr === 18
                                    ? "d-block text-red"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===3 || pr===4 || pr===17 || pr===18 ? -money : profit} */}
                              </span>
                              SUSPENDED
                              {/* 
                            {back1.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-3 h-75 text-center cursor-pointer ${
                                  index < back1.length - 1
                                    ? "bg-secondary1 dnone"
                                    : "bg-info1"
                                }`}
                                onClick={() => {
                                  setbackActive(1);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(1);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Back');
                                  setSelectedBet(0)
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}

                        

                            {lay1.map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-3 h-75 text-center cursor-pointer ${
                                  index === 0 ? "bg-pink1" : "bg-secondary1 dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(4);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(2);
                                  setSelectedId(selectionid1);
                                  setRunner(runner1);
                                  setSide('Lay');
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>

                          <div
                            className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-1 p-1"
                            style={{ borderBottom: "1px solid #d3cece" }}
                          >
                            <h5
                              className="fs-4 text-wrap run m-0"
                              style={{ color: "var(--dark-theme-white-color)" }}
                              id={selectionid2}
                            >
                              {runner2}
                            </h5>

                            <div
                              className="d-flex gap-1"
                              style={{ color: "var(--dark-theme-white-color)" }}
                            >
                              <span
                                className={`${
                                  pr === 3
                                    ? "d-block text-green"
                                    : pr === 4
                                    ? "d-block text-green"
                                    : pr === 1 ||
                                      pr === 2 ||
                                      pr === 17 ||
                                      pr === 18
                                    ? "d-block text-red"
                                    : "d-none"
                                }`}
                              >
                                {"=>"}
                                {/* {pr===1 || pr===2 || pr===17 || pr===18 ? -money : profit } */}
                              </span>
                              SUSPENDED
                              {/*                        
                            {back2.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index < back2.length - 1
                                    ? "bg-secondary1 dnone"
                                    : "bg-info1"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(3);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay2.map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index === 0 ? "bg-pink1" : "bg-secondary1 dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(4);
                                  setSelectedId(selectionid2);
                                  setRunner(runner2);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))} */}
                            </div>
                          </div>
                          {/* <div className="betting-row d-flex flex-md-row justify-content-between align-items-md-center border-1 p-1" style={{ borderBottom: "1px solid #d3cece" }}>
                          <h5 className="fs-4 text-wrap run m-0" style={{ color: 'var(--dark-theme-white-color)' }} id={selectionid3}>{runner3}</h5>
                          
                          <div className="d-flex gap-1" style={{ color: 'var(--dark-theme-white-color)' }}>
                          <span
                              className={`${
                                pr === 17
                                  ? "d-block text-green"
                                  : pr === 18
                                  ? "d-block text-green"
                                  : (pr===1 || pr===2  || pr===3 || pr === 4) 
                                  ? 'd-block text-red'
                                  : 'd-none'
                              }`}
                            >
                              {"=>"}
                              {pr===1 || pr===2 || pr===3 || pr === 4 ? -money : profit }
                            </span>
                       
                            {back3.slice().reverse().map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index < back2.length - 1
                                    ? "bg-secondary1 dnone"
                                    : "bg-info1"
                                }`}
                                onClick={() => {
                                  setbackActive(2);
                                  setlayActive(3);
                                  setSelectedPrice(bc.price);
                                  setPr(17);
                                  setSelectedId(selectionid3);
                                  setRunner(runner3);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                            
                            {lay3.map((bc, index) => (
                              <div
                                className={`rounded px-1 py-0 fs-5 h-100 text-center cursor-pointer fw-bold ${
                                  index === 0 ? "bg-pink1" : "bg-secondary1 dnone"
                                }`}
                                onClick={() => {
                                  setlayActive(5);
                                  setbackActive(0);
                                  setSelectedPrice(bc.price);
                                  setPr(18);
                                  setSelectedId(selectionid3);
                                  setRunner(runner3);
                                  setSelectedBet(0);
                                }}
                                style={{width:'4rem'}}
                              >
                                {bc.price}
                              </div>
                            ))}
                          </div>
                        </div> */}
                        </div>

                        {/* betting back div */}
                        {/* {backActive !== 0 && (
                        <div style={{ backgroundColor: 'var(--dark-theme-data-homebet)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ backgroundColor: 'var(--dark-theme-data-backbtn)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            BACK
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div    style={{ display: "flex", alignItems: "center" }  }>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div  className="w-25" style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                className="homebet_set"
                                style={{ color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                              className="homebet_set"  
                              style={{ color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                          className="homebet_set"  
                          style={{ color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )}
                         {layActive !== 3 && (
                        <div style={{ backgroundColor: 'var(--dark-theme-data-homebet2)', padding: "15px", color: 'var(--dark-theme-color-navbar)', borderRadius: "5px", width: "100%" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 20px", border: "none", borderRadius: "5px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >
                            Lay
                          </button>
                          <div style={{ color: "#4ADE80", fontWeight: "bold" }}>
                            Profit: {(money * (selectedPrice - 1)).toFixed(1)}
                          </div>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <input type="checkbox" style={{ width: "18px", height: "18px", marginRight: "8px" }} id="matchAtAnyRate" />
                            <label htmlFor="matchAtAnyRate">Match At Any Rate</label>
                          </div>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Odds</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handlelayChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={selectedPrice}
                                onChange={(e) => setSelectedPrice(e.target.value)}
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handlelayChange(1)}
                              >+</button>
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ textAlign: "center", marginBottom: "5px" }}>Stake</div>
                            <div style={{ display: "flex", height: "40px" }}>
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px 0 0 4px" }}
                                onClick={() => handleChange(0)}
                              >−</button>
                              <input
                                type="text"
                                value={money}
                                onChange={(e) => setMoney(e.target.value)}
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', border: "none", flex: 1, textAlign: "center", fontSize: "18px" }}
                              />
                              <button 
                                style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', width: "40px", border: "none", fontSize: "20px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "0 4px 4px 0" }}
                                onClick={() => handleChange(1)}
                              >+</button>
                            </div>
                          </div>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(100)}
                          >+ 100</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(200)}
                          >+ 200</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(500)}
                          >+ 500</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(1000)}
                          >+ 1k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(5000)}
                          >+ 5k</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(10000)}
                          >+ 10k</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(25000)}
                          >+ 25k</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-set2)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "normal" }}
                            onClick={() => setMoney(50000)}
                          >+ 50k</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px", marginBottom: "8px" }}>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-min)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Min</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-dark-blue-bm)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Max</button>
                          <button style={{ backgroundColor: 'var(--dark-theme-data-stake)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}>Edit Stake</button>
                          <button 
                            style={{ backgroundColor: 'var(--dark-theme-data-clear)', color: 'var(--dark-theme-color-navbar)', padding: "8px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setMoney(0);
                              setPr(0);
                            }}
                          >Clear</button>
                        </div>
                        
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px" }}>
                          <button 
                            style={{ background: 'var(--dark-theme-data-cancel)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => {
                              setbackActive(0);
                              setMoney(0);
                              setPr(0);
                            }}
                          >Cancel</button>
                          <button 
                            style={{ background: 'var(--dark-theme-data-submit)', color: 'var(--dark-theme-color-navbar)', padding: "12px 0", border: "none", borderRadius: "3px", fontWeight: "bold" }}
                            onClick={() => handleSubmit()}
                          >Submit</button>
                        </div>
                      </div>
                      )} */}
                      </div>
                    </div>

                    <div className="bets-container d-flex flex-column betTv  gap-5 ">
                      {role !== "demo" && token && (
                        <div className="d-none d-lg-block position-relative pl-1">
                          <div
                            className="p-2 cursor-pointer d-flex justify-content-between bg-black"
                            onClick={() => setPlay(!play)}
                          >
                            <div>
                              <span>
                                <i
                                  className="bi bi-broadcast fs-16"
                                  style={{
                                    color: "var(--dark-theme-demoaccount)",
                                  }}
                                ></i>
                              </span>
                              <span> Watch Live Match</span>
                            </div>
                            <div>
                              <button className="live-stream-button ng-star-inserted">
                                Watch Live
                              </button>
                            </div>
                          </div>

                          {play && channel && (
                            <iframe
                              title="Live TV"
                              className="border w-100 h-75"
                              // src={`https://cache.bpexchanges.com/embed?eventId=${channel}`}
                              src={`/proxy-stream/${channel}`}
                              allowFullScreen
                              referrerPolicy="strict-origin-when-cross-origin"
                              sandbox="allow-same-origin allow-scripts"
                            ></iframe>
                          )}
                        </div>
                      )}

                      <div
                        className={`mt-3 mt-lg-0 ms-0 ms-lg-3 mb-4  h-100 ${isAuthenticated ? "" : "d-none"}`}
                        style={{
                          maxHeight: "100vh",
                          height: `${betData?.length * 6}vh`,
                          backgroundColor: "var(--dark-theme-color-navbar)",
                        }}
                      >
                        <p
                          className="m-0 px-2 py-1 bett"
                          style={{
                            background: "var(--dark-theme-bg)",
                            color: "var(--rb-text)",
                          }}
                        >
                          My Bets
                        </p>

                        {/* <table
                          className=" border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <div
                              style={{
                                color: 'var(--dark-theme-color-navbar)',
                                fontFamily: "sans-serif",
                              }}
                              className="pl-1"
                            >
                              Unmatched bets
                            </div>
                            <tr>
                              <th>Runner Name</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>P/L</th>
                            </tr>
                          </thead>

                          <tbody>
                            {unmatch?.length > 0 ? (
                              unmatch?.map((bet, index) => (
                                <tr key={index}>
                                  <td>
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td>{bet.betprice}</td>
                                  <td>{bet.betAmount}</td>
                                  <td>{bet.profit}</td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table> */}

                        <table
                          className="table border  w-100"
                          style={{ borderCollapse: "collapse" }}
                        >
                          <thead>
                            <tr className="text-black">
                              <th>Runner Name</th>
                              <th>ODDS</th>
                              <th>Bet Amount</th>
                              <th>Side</th>
                              {/* <th>P/L</th> */}
                            </tr>
                          </thead>

                          <tbody>
                            {betData?.length > 0 ? (
                              betData?.map((bet, index) => (
                                <tr
                                  key={`sports-${index}`}
                                  className="boder border-black"
                                  style={{
                                    backgroundColor:
                                      bet?.side === "Back"
                                        ? "var(--dark-theme-data-box)"
                                        : "#faa9ba",
                                    color: "black",
                                  }}
                                >
                                  <td
                                    style={{
                                      backgroundColor:
                                        bet?.side === "Back"
                                          ? "var(--dark-theme-data-box)"
                                          : "#faa9ba",
                                      color: "black",
                                    }}
                                  >
                                    {bet.runnerName}&nbsp;({bet.type})
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor:
                                        bet?.side === "Back"
                                          ? "var(--dark-theme-data-box)"
                                          : "#faa9ba",
                                      color: "black",
                                    }}
                                  >
                                    {bet.betprice}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor:
                                        bet?.side === "Back"
                                          ? "var(--dark-theme-data-box)"
                                          : "#faa9ba",
                                      color: "black",
                                    }}
                                  >
                                    {bet.betAmount}
                                  </td>
                                  <td
                                    style={{
                                      backgroundColor:
                                        bet?.side === "Back"
                                          ? "var(--dark-theme-data-box)"
                                          : "#faa9ba",
                                      color: "black",
                                    }}
                                  >
                                    {bet.side}
                                  </td>
                                  {/* <td>{bet.profit}</td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                {/* <td className=" text-white bett" onClick={()=> setActive(true)}>Login required</td>
                            <td className=" text-white bett">to view</td>
                            <td className=" text-white bett">bet data</td> */}
                                <td>No bet data</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <MarqueeBottom onMenuClick={handleCanvasShow} />
            </div>
          </app-landing-page-new>
        </div>
      </app-root>
    </>
  );
};

export default FootBAll;
